import { render, staticRenderFns } from "./storeToString.vue?vue&type=template&id=2dc42d1f&scoped=true&"
import script from "./storeToString.vue?vue&type=script&lang=js&"
export * from "./storeToString.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc42d1f",
  null
  
)

export default component.exports